<template>
  <div class="width-100 min-height" id="body-div" style="padding: 20px 5%; background: #f7f7f7">
    <!-- <van-field style="width: 100%; border: 1px solid #eee" placeholder="请输入要搜索的记录" v-model="searchObj.name" @keyup.enter="onRefresh" /> -->
    <div class="width-100 flex-row align-items-center justify-content-end" style="color: #1e67f7" @click="show = true">
      {{ searchObj.begin_date2 }} - {{ searchObj.end_date2 }}
    </div>
    <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="width-100 height-100 margin-ts">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length == 0 ? '' : '没有更多了'"
        @load="onLoad"
        class="width-100 height-100"
      > -->
    <div
      class="width-100 border br-reg overflow-h bg-white flex-row align-items-center justify-content-spaceBetween margin-b position-relative"
      style="padding: 10px 5%"
      v-for="(item, key) in list"
      :key="key"
    >
      <div class="width-75 flex-row align-items-center justify-content-spaceBetween" style="height: 3.5rem">
        <div style="width: 30%; height: 3.5rem" class="border br-reg flex-row align-items-center justify-content-center">
          <van-image :src="require('../../assets/image/shop/avatar.png')" width="3rem" height="3rem" fit="contain" />
        </div>
        <div class="fs-mid black line-height fw-mid width-65 canNotWrap show-line-1">{{ item.write_user_name }}</div>
      </div>
      <div
        class="position-absolute white fs-mid-sml textAlign-c"
        style="padding: 5px 10px; bottom: 0; right: 0; background: #1e67f7; border-radius: 5px"
      >
        核销数：{{ item.num }}
      </div>
    </div>
    <van-empty v-if="emptyShow" description="暂无统计记录" />
    <van-calendar :min-date="new Date('2023/01/01')" :max-date="new Date()" v-model="show" type="range" @confirm="onConfirm" />
  </div>
</template>

<script>
import { Toast } from 'vant';
import { get_statistics_analysis } from '@/api/shop';
export default {
  data() {
    return {
      show: false,
      emptyShow: false,
      refreshing: false,
      bodyWidth: '',
      list: [],
      loading: false,
      finished: false,
      searchObj: {
        pageNum: 0,
        pageSize: 10,
        begin_date: '',
        end_date: '',
        begin_date2: '',
        end_date2: '',
        name: ''
      }
    };
  },
  beforeMount() {
    this.$nextTick(() => {
      this.bodyWidth = document.getElementById('body-div').clientWidth;
    });
    let time = new Date();
    this.searchObj.begin_date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-01';
    this.searchObj.end_date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
    this.searchObj.begin_date2 = time.getFullYear() + '年' + (time.getMonth() + 1) + '月1日';
    this.searchObj.end_date2 = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getDeptLists();
    },
    getDeptLists() {
      get_statistics_analysis({
        page: this.searchObj.pageNum,
        begin_date: this.searchObj.begin_date,
        end_date: this.searchObj.end_date,
        name: this.searchObj.name
      }).then((res) => {
        if (res.code == 0) {
          this.list = this.list.concat(res.data);
          let list = this.list.concat(res.data);
          if (res.data.length == 0) {
            this.finished = true;
          }
          if (list.length == 0) {
            this.emptyShow = true;
          }
        } else {
          Toast(res.msg);
          this.finished = true;
        }
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      this.list = [];
      this.searchObj.pageNum = 0;
      this.emptyShow = false;
      this.finished = false;
      this.onLoad();
    },
    onConfirm(e) {
      let time = new Date(e[0]);
      let time2 = new Date(e[1]);
      this.searchObj.begin_date = this.$dayjs(new Date(e[0])).format('YYYY-MM-DD');
      this.searchObj.end_date = this.$dayjs(new Date(e[1])).format('YYYY-MM-DD');
      this.searchObj.begin_date2 = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
      this.searchObj.end_date2 = time2.getFullYear() + '年' + (time2.getMonth() + 1) + '月' + time2.getDate() + '日';
      this.show = false;
      this.onRefresh();
    }
  }
};
</script>

<style scoped>
::v-deep .van-cell::after {
  border: unset;
}
</style>